/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';
import { PortfolioUpdateDto } from '../../models/portfolio-update-dto';

export interface PortfolioAdminControllerUpdateV1$Params {
  id: string;
      body: PortfolioUpdateDto
}

export function portfolioAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: PortfolioAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioDto>;
    })
  );
}

portfolioAdminControllerUpdateV1.PATH = '/api/v1/portfolios/admin/{id}';
